import { IDLE_LOGOUT_SECONDS, LAST_ACTIVITY_KEY } from "../constants/autoLogout";

// The idle timers in AppBar/AppLogout only run while a tab is open. If the browser was closed
// and reopened later, nothing else would notice the gap — the first 401 would be silently
// refreshed and the user would stay logged in. Checked once in index.js before the app renders,
// so no API call fires and AppBar can't overwrite lastActivity first.
export function isSessionStale(now: number = Date.now()): boolean {
  // "currentUserId" is the same "is there a session" marker useToken/AppLogout read.
  if (!localStorage.getItem("currentUserId")) return false;
  const lastActivity = parseInt(localStorage.getItem(LAST_ACTIVITY_KEY) || "0", 10);
  return now - lastActivity > IDLE_LOGOUT_SECONDS * 1000;
}
